module.exports = __webpack_public_path__ + "static/header-084a45f696475b5bc5cfdfb7d419d8c7.jpg";